<div class="fms-notification-panel">
  <div class="fms-notification-panel__header">
    <h3 class="fms-notification-panel__title">Notifications</h3>
    <button
      vng-button
      variant="ghost"
      size="sm"
      type="button"
      [disabled]="(unreadCount$ | async) === 0"
      (click)="onMarkAllRead()"
    >
      Mark all as read
    </button>
  </div>

  <vng-pill-tabs [tabs]="tabs" [activeIndex]="activeTabIndex" (activeIndexChange)="onTabChange($event)">
  </vng-pill-tabs>

  <div
    class="fms-notification-panel__list"
    role="list"
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="1.5"
    [infiniteScrollThrottle]="150"
    (scrolled)="onScrolled()"
  >
    <vng-skeleton-rows *ngIf="loading$ | async" [rows]="4"></vng-skeleton-rows>

    <ng-container *ngIf="(loading$ | async) === false">
      <app-notification-item
        *ngFor="let notification of notifications$ | async; trackBy: trackById"
        [notification]="notification"
      ></app-notification-item>

      <vng-empty-state
        *ngIf="(notifications$ | async)?.length === 0"
        class="fms-notification-panel__empty-state"
        title="You're all caught up"
        subtitle="No notifications yet."
      ></vng-empty-state>
    </ng-container>
  </div>
</div>
